import Link from 'next/link'
import SolidButton from '@/components/Common/Button/SolidButton'
import { useParams } from 'next/navigation'
import { useTranslation } from 'react-i18next'

const ResumeApplication = ({ isKtpDomain = false }: { isKtpDomain?: boolean }) => {
  const params = useParams()
  const id = params.id as string
  const { t } = useTranslation('common')

  return (
    <>
      <div className="flex items-center justify-center">
        {isKtpDomain ? (
          <p className="text-sm font-semibold text-white lg:text-lg">
            협력과제 지원서를 이어서 작성해보세요
          </p>
        ) : (
          <p className="text-sm font-semibold text-normal lg:text-lg">
            {t('cta.resume.message')}
          </p>
        )}
      </div>
      <div className={`w-full ${isKtpDomain ? 'lg:max-w-[175px]' : 'lg:max-w-[160px]'}`}>
        <Link href={`/${id}/apply`}>
          <SolidButton
            className={`!h-10 !w-full lg:!h-11 ${isKtpDomain ? '!bg-white !text-[#3385FF] !whitespace-nowrap' : ''}`}>
            {isKtpDomain ? '이어서 신청하기' : t('cta.resume.button')}
          </SolidButton>
        </Link>
      </div>
    </>
  )
}

export default ResumeApplication
